export const colourStyles = (error) => ({
  control: (base) => ({
    ...base,
    '&:hover': { borderColor: error ? '#EA5506' : '#BFBFBF' },
    border: error ? '1px solid #EA5506' : '1px solid #BFBFBF',
    boxShadow: 'none',
    display: 'flex',
    flexDirection: 'row-reverse',
  }),
  multiValue: (base) => ({
    ...base,
    border: '1px solid #0FBC71',
    borderRadius: '200px',
    backgroundColor: 'rgba(15, 188, 113, 0.05)',
    color: '#0FBC71',
    padding: '6px 10px',
    fontSize: '12px',
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: '#0FBC71',
  }),
  option: (base) => ({
    ...base,
    color: '#343741',
    fontSize: '14px',
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: '#959595',
    fontSize: '14px',
  }),
  input: (base) => ({
    ...base,
    color: '#444444',
    fontSize: '14px',
  }),
});

export const customFilterStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: '8px',
    border: '1px solid #CCD5DF',
    boxShadow: state.isFocused ? 'none' : provided.boxShadow,
    '&:hover': { border: '1px solid #CCD5DF', cursor: 'pointer' },
    '&:focus': {
      border: 'none',
      outline: 'none',
    },
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: '#647187',
    fontSize: '14px',
  }),
};

export const customFilterButtonStyles = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: '16px',
    border: state.hasValue ? '1px solid #3F566A' : '1px solid #ccd5df',
    backgroundColor: state.hasValue ? '#CED5DE' : '#fff',
    boxShadow: state.isFocused ? 'none' : provided.boxShadow,
    width: 'max-content',
    '&:focus': {
      backgroundColor: 'black',
      border: 'none ',
      outlline: 'none',
      cursor: 'pointer',
    },
    '&:hover': {
      border: state.hasValue ? '1px solid #3F566A' : '1px solid #ccd5df',
      outlline: 'none',
      cursor: 'pointer',
    },
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '12px',
    fontWeight: 500,
    padding: '10px 12px',
    marginBottom: '4px',
    borderRadius: '6px',
    // eslint-disable-next-line no-nested-ternary
    background: state.isSelected ? '#DDE2E8' : state.isFocused ? '#EAECF0' : '#FFFFFF',
    color: '#314155',
    '&:focus': {
      backgroundColor: '#EAECF0',
    },
    '&:hover': {
      cursor: 'pointer',
    },
    '&:active': {
      backgroundColor: '#EAECF0',
    },
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    paddingLeft: 0,
    '&:hover': {
      cursor: 'pointer',
    },
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontWeight: 500,
    color: state.isFocused ? '#1A293A' : '#314155',
    fontSize: '12px',
  }),
  menu: (provided) => ({
    ...provided,
    border: '1px solid #F2F4F7',
    borderRadius: '8px',
    boxShadow: '0px 20px 24px -4px rgba(14, 24, 41, 0.08), 0px 8px 8px -4px rgba(14, 24, 41, 0.03)',
    width: '219px',
    padding: '4px 4px',
    zIndex: 9999,
    '&:hover': {
      cursor: 'pointer',
    },
  }),
};
